import actionTypes from '../constants/action-types';

export default (ownerId) => ({
  type: actionTypes.SET_OWNER_ID,
  payload: {
    ownerId,
  },
});
